module.exports = __webpack_public_path__ + "d77246f061083a1d761e2e890acb6172.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-10.png
// module id = 2961
// module chunks = 0